import { Ref } from "vue";
import { Router } from "vue-router";

// Interfaces
export interface PromotionData {
  show: boolean
  promotionList: any[]
}

export interface PromotionItem {
  name: string
  image?: string
  icon?: string
  unclaimed_count?: number
  activity_icon?: string
}
// Functions
export const activityCount = (
  activityNotice: { id: number; msgList: number[] }[],
  id: number
): number => {
  const found = activityNotice.find(item => item.id === id);
  return found ? found.msgList.length : 0;
};

export const goToRedirectPath = <T extends string>(
  isPopping: Ref<boolean>,
  itemData: PromotionItem,
  router: Router,
  emits: (event: T, ...args: any[]) => void,
  playClickSound: () => void
): void => {
  isPopping.value = true
  playClickSound()
  localStorage.setItem('openPromotionPopup', 'true')

  const name = itemData.name

  setTimeout(() => {
    isPopping.value = false
    console.log("name", name)
    switch (name) {
      case 'user_referral_reward': router.push('/sdagency'); break
      case 'lucky_wheel': router.push('/cashwheel'); break
      case 'recharge_bargain_sales': router.push('/sdbigdep'); break
      case 'agent_cash_back':
        localStorage.setItem('agentOpenFromPromotion', 'true')
        emits('openAgentPopup' as T);
        break
      case 'vip_reward': router.push('/sd-vip'); break
      case 'red_envelope_rain': emits('openRedEnvelop' as T); break
      case 'game_benefit': router.push('/lossRelief'); break
      case 'mystery': router.push('/sdmystery'); break
      case 'user_rank': router.push('/sd-level'); break
      case 'first_recharge': router.push('/firstRecharge'); break
      case 'recharge_gift': router.push('/rechargeGift'); break
      case 'return_turnover': router.push('/returnTrunover'); break
      case 'daily_first_recharge': router.push('/firstDeposit'); break
      case 'active_tresure_chest': router.push('/sdactivechest'); break
      case 'signin_rewards': router.push('/checkinRewards'); break
      case 'redeem_code': router.push('/giftCode'); break
      case 'active_bonus': router.push('/activeBonus'); break
      case 'pwa_reward': emits('openPWA' as T); break
      default: emits('goToHome' as T); break
    }
  }, 500)
}